import { render, staticRenderFns } from "./YTable.vue?vue&type=template&id=c1baee7e&scoped=true"
import script from "./YTable.vue?vue&type=script&lang=js"
export * from "./YTable.vue?vue&type=script&lang=js"
import style0 from "./YTable.vue?vue&type=style&index=0&id=c1baee7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1baee7e",
  null
  
)

export default component.exports